import _ from "lodash";
import ACLStore from "lib/aclStore";
import { getCloudUrl } from "Constants";
import { SNPv2_VISITOR_MODULE_PERM } from "Constants/permissionConstants";
import { store } from "store/createStore";
import { parseConfigurationValue } from "Utils";
import { readConfigurationFragmentV2 } from "modules/CommonGraphqlHelpers";
import {
  getAcademicYearForCurriculumProgram,
  getCurriculumProgramIdFromRoute,
  getUserId,
} from "modules/CommonSelectors";
import { getIsAYWisePermsSetupEnabled } from "Utils/ACLStoreUtils";

// re-exporting getSettingValue from ConfigurationUtils for backward compatibility
export { getSettingValue } from "Utils/ConfigurationUtils";

export const SCHEDULE_MEETING_URL = "https://meetings.hubspot.com/deepanshu3";

export const FEATURE_PERMISSION_MAPPING = {
  SCHEDULER: "TeacherPortal:Scheduler",
  YEARLY_INSIGHT: "TeacherPortal:YEARLY_INSIGHT",
  POI: ["TeacherPortal:POI", SNPv2_VISITOR_MODULE_PERM],
  ATTENDANCE: "TeacherPortal:Attendance",
  EVIDENCE: ["TeacherPortal:Evidence", SNPv2_VISITOR_MODULE_PERM],
  SNS_EDITOR: "AdminPortal:SnsEditor",
  PORTFOLIO_REPORTS: "TeacherPortal:PortfolioReports",
  FAMILY_COMMUNICATION: "TeacherPortal:FamilyCommunications",
};

export const LOCKED_SCREEN_CONFIG = {
  YEARLY_INSIGHT: {
    heading: "yearly_insight_heading",
    subHeading: "yearly_insight_subHeading",
    images: [
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/planning/yearlyInsight.png`,
      },
    ],
    showCancelIcon: true,
  },

  POI: {
    heading: "poi_heading",
    images: [
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/planning/feature_poi.png`,
        label: "poi_view",
      },
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/planning/poiInsight.png`,
        label: "poi_insights",
      },
    ],
    subHeading: "poi_subHeading",
  },
  EVIDENCE: {
    heading: "evidence_heading",
    showFeatures: true,
    showCTA: true,
    productType: "evidence",
    images: [
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/hero/evidenceHero.png`,
      },
    ],
    subHeading: "evidence_subHeading",
  },
  SNS_EDITOR: {
    heading: "sns_editor_heading",
    showFeatures: true,
    showCTA: true,
    images: [
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/hero/evidenceHero.png`,
      },
    ],
    subHeading: "sns_editor_subHeading",
  },
  FILE_SIZE_LIMIT: {
    heading: "file_size_limit_heading",
    showFeatures: true,
    showCTA: true,
    images: [
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/hero/evidenceHero.png`,
      },
    ],
    subHeading: "file_size_limit_subHeading",
  },
  SCHEDULER: {
    heading: "scheduler_heading",
    subHeading: "scheduler_subHeading",
    images: [
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/hero/schedulerHero.png`,
      },
    ],
    hasScrollable: true,
    showFeatures: true,
    showCTA: true,
    productType: "scheduler",
  },
  PORTFOLIO_REPORTS: {
    heading: "portfolio_reports_heading",
    showFeatures: true,
    showCTA: true,
    productType: "report",
    hasScrollable: true,
    images: [
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/hero/reportHero.png`,
      },
    ],
    subHeading: "portfolio_reports_subHeading",
  },
  FAMILY_COMMUNICATION: {
    heading: "family_communication_heading",
    showFeatures: true,
    showCTA: true,
    productType: "communication",
    hasScrollable: true,
    images: [
      {
        image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/hero/communicationHero.png`,
      },
    ],
    subHeading: "family_communication_subHeading",
  },
  IMPORT_LE: {
    subText: "toddle_360_users",
    heading: "assign_assessment",
    subHeading: "toddle_360_le_assignment",
    upgradeText: "contact_upgrade_subscription",
    customFooter: true,
    smallContainer: true,
  },
  IMPORT_LE_ADMIN: {
    subText: "toddle_360_users",
    heading: "assign_assessment",
    subHeading: "toddle_360_le_assignment",
    upgradeText: "about_toddle_360",
    customFooter: true,
    smallContainer: true,
    showContactButton: true,
  },
};

export const ProductFeatures = {
  evidence: {
    photoOnLeftType: "even",
    features: [
      {
        key: "Evidence",
        title: "evidence_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/evidence/evidence.png`,
        description: "evidence_des",
      },
      {
        key: "Tag PYP Post",
        title: "tag_pyp_post_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/evidence/tagPYPPost.png`,
        description: "tag_pyp_post_des",
      },
      {
        key: "Reflection",
        title: "reflection_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/evidence/reflection.png`,
        description: "reflection_des",
      },
    ],
  },
  report: {
    photoOnLeftType: "odd",
    features: [
      {
        key: "Post Card",
        title: "post_card_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/report/postCard.png`,
        description: "post_card_des",
      },
      {
        key: "Student Assessment",
        title: "student_assessment_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/report/studentAssessment.png`,
        description: "student_assessment_des",
      },
      {
        key: "PYP Evaluation",
        title: "pyp_evaluation_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/report/pypEvaluation.png`,
        description: "pyp_evaluation_des",
      },
      {
        key: "Progress Report",
        title: "progress_report_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/report/porgressReport.png`,
        description: "progress_report_des",
      },
      {
        key: "Student Goal",
        title: "student_goal_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/report/studentGoals.png`,
        description: "student_goal_des",
      },
    ],
  },
  communication: {
    photoOnLeftType: "even",
    features: [
      {
        key: "Parent Journal",
        title: "parent_journal_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/communication/parentJournal.png`,
        description: "parent_journal_des",
      },
      {
        key: "ParentProgressReport",
        title: "parent_progress_report_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/communication/parentProgressReport.png`,
        description: "parent_progress_report_des",
      },
      {
        key: "ParentPolicy",
        title: "parent_policy_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/communication/parentPolicy.png`,
        description: "parent_policy_des",
      },
    ],
  },
  scheduler: {
    photoOnLeftType: "odd",
    features: [
      {
        key: "YearlyScheduler",
        title: "yearly_scheduler_title",
        images: [
          {
            image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/planning/yearlyScheduler.png`,
            label: "yearly_view",
          },
          {
            image: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/planning/yearlyInsight.png`,
            label: "yearly_insights",
          },
        ],
        description: "yearly_scheduler_des",
      },
      {
        key: "WeeklyScheduler",
        title: "weekly_scheduler_title",
        images: `${getCloudUrl()}/assets/toddleapp.com/illustrations/feature/planning/weeklyScheduler.png`,
        description: "weekly_scheduler_des",
      },
    ],
  },
};

export const getPermissionState = key => {
  const perm = FEATURE_PERMISSION_MAPPING[key];

  return ACLStore.getPermissionState(perm);
};

/**
 * Note this util is for temporary fix. Remove it when curriculum based perm is integrated
 */
export const getPermissionStateBasedOnSubscriptionPlan = ({
  key,
  isCurriculumProgramFree,
}) => {
  /**
   * For paid curriculum programs, use default behaviour
   */
  if (!isCurriculumProgramFree) {
    return getPermissionState(key);
  }

  /**
   * For free curriculum programs, if feature is enabled, treat it as locked, otherwise treat as disabled
   * Note: when feature is locked, lock screen will be shown
   */

  const perm = FEATURE_PERMISSION_MAPPING[key];

  const isFeatureEnabled = ACLStore.can(perm);

  if (isFeatureEnabled) {
    return "LOCKED";
  }
  return "DISABLED";
};

export const isFeatureLocked = key => {
  const perm = FEATURE_PERMISSION_MAPPING[key];

  return ACLStore.isLocked(perm);
};

export const getIsConfigurationEnabledForCPAY = args => {
  const isAYWisePermsSetupEnabled = getIsAYWisePermsSetupEnabled();

  const state = store?.getState();

  const configuration = _.get(args, "configuration");
  if (!configuration) {
    return false;
  }

  let curriculumProgramId = _.get(
    args,
    "curriculumProgramId",
    _.get(state, "platform.currentCurriculumProgram.id", undefined)
  );

  if (_.isEmpty(curriculumProgramId)) {
    // try extracting curriculumProgramId from admin portal routes
    curriculumProgramId = getCurriculumProgramIdFromRoute(state);
  }

  let academicYearId = _.get(args, "academicYearId", null);

  if (!academicYearId && curriculumProgramId) {
    // If academicYearId is not provided, try to get it from the curriculum program
    academicYearId = getAcademicYearForCurriculumProgram(state, {
      curriculumProgramId,
    })?.id;
  }

  if (curriculumProgramId && (academicYearId || !isAYWisePermsSetupEnabled)) {
    const configurationEntityGroups = [
      {
        entityType: "CURRICULUM_PROGRAM",
        entityId: curriculumProgramId,
      },
    ];

    if (isAYWisePermsSetupEnabled) {
      configurationEntityGroups.push({
        entityType: "ACADEMIC_YEAR",
        entityId: academicYearId,
      });
    } else {
      configurationEntityGroups.push({
        entityType: "USER",
        entityId: getUserId(state),
      });
    }

    const configurationVariables = {
      configurationEntityGroupFilters: [
        {
          configurationEntityGroups,
        },
      ],
    };

    const settingValue = readConfigurationFragmentV2(
      configurationVariables,
      configuration
    );

    return parseConfigurationValue(settingValue);
  }

  return ACLStore.can(configuration);
};
